import React, { useEffect, useState } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const SpinnerWithMessage = ({ progress = 0, message = 'Downloading...' }) => {
  const [progressVal, setProgressVal] = useState(0);
  useEffect(() => {
    if (progressVal < progress) {
      for (let i = progressVal + 1; i <= progress;  i += 1) {
        setTimeout(() => {
          setProgressVal(i);
        }, (i - progressVal) * 30); // delay increases for each step
      }
    }
  }, [progress]);
  
  return (
    <Box display="flex" alignItems="center" padding="8px 12px">
      <Box position="relative" display="inline-flex" marginRight={2}>
        <CircularProgress variant="determinate" value={progress} size={48} thickness={4} sx={{ color: '#1976d2' }} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="body1" component="div" sx={{ fontSize: '0.75rem', p: 1, fontWeight: 500 }}>
            {`${Math.round(progressVal)}%`}
          </Typography>
        </Box>
      </Box>
      <Typography variant="body1" sx={{ fontSize: '0.85rem' }}>
        {message}
      </Typography>
    </Box>
  );
};

export default SpinnerWithMessage;
